<h6 mat-dialog-title>

    {{ modalTitle }}

    <br>

    {{ invoiceTitle }}

</h6>

<mat-dialog-content class="mat-typography">

    <div class="container-fluid stdTheme">

        <form [formGroup]="invoiceStatusForm">

            <!-- Ligne 1 : Statut actuel -->

            <div class="row status-row">

                <div class="col-12">

                    <mat-form-field
                        class="wksInput form-group"
                        appearance="standard">

                        <mat-label>

                            {{ 'invoiceTrackingStatusCur' | translate }}

                        </mat-label>

                        <input
                            id="invoiceStatusCur"
                            class="form-control inputTheme"
                            matInput
                            formControlName="invoiceStatusCur"
                            readonly>

                    </mat-form-field>

                </div>

            </div>


            <!-- Ligne 2 : Nouveau statut + Motif -->

            <div class="row status-row">

                <!-- Nouveau statut -->

                <div class="col-6">

                    <mat-form-field
                        class="wksInput form-group"
                        appearance="standard">

                        <mat-label>

                            {{ 'invoiceTrackingStatusNew' | translate }}

                        </mat-label>

                        <mat-select
                            id="invoiceStatusNew"
                            #invoiceStatusNew
                            formControlName="invoiceStatusNew"
                            panelClass="mdiselectcontent"
                            required
                            (selectionChange)="
                                onChangeInvoiceStatus(
                                    invoiceStatusNew.value
                                )
                            ">

                            <mat-option
                                class="selectOptionsTheme"
                                *ngFor="
                                    let status
                                    of invoiceStatusList
                                "
                                [value]="status.value"
                                [disabled]="status.disabled">

                                {{ status.label }}

                            </mat-option>

                        </mat-select>

                    </mat-form-field>

                </div>


                <!-- Code / libellé du motif -->

                <div
                    class="col-6"
                    *ngIf="requiresReason">

                    <mat-form-field
                        class="wksInput form-group"
                        appearance="standard">

                        <mat-label>

                            {{ 'invoiceReasonCode' | translate }}

                        </mat-label>

                        <mat-select
                            id="invoiceStatusReasonCode"
                            #invoiceStatusReasonCode
                            formControlName="reasonCode"
                            panelClass="mdiselectcontent"
                            (selectionChange)="
                                onReasonCodeChange(
                                    invoiceStatusReasonCode.value
                                )
                            ">

                            <mat-option
                                class="selectOptionsTheme"
                                *ngFor="
                                    let reason
                                    of reasonCodeList
                                "
                                [value]="reason.code">

                                {{
                                    reason.code === ''
                                        ? ('invoiceReasonCodeCustom' | translate)
                                        : (reason.code | translate)
                                }}

                            </mat-option>

                        </mat-select>

                        <mat-error
                            *ngIf="
                                invoiceStatusForm
                                    .controls
                                    .reasonCode
                                    .hasError('required')
                            ">

                            {{ 'invoiceReasonCodeRequired' | translate }}

                        </mat-error>

                    </mat-form-field>

                </div>

            </div>


            <!-- Ligne 3 : Texte libre -->

            <div
                class="row reason-row"
                *ngIf="requiresReason">

                <div class="col-12">

                    <mat-form-field
                        class="wksInput form-group reason-field"
                        appearance="standard">

                        <mat-label>

                            {{ 'invoiceReason' | translate }}

                        </mat-label>

                        <textarea
                            id="invoiceStatusReason"
                            class="form-control inputTheme"
                            matInput
                            formControlName="reason"
                            rows="3"
                            maxlength="500">
                        </textarea>

                    </mat-form-field>

                </div>

            </div>

        </form>

    </div>

</mat-dialog-content>


<mat-dialog-actions align="center">

   <button
        type="button"
        class="mat-raised-button buttonTheme"
        (click)="onNoClick()">
        {{ 'cancel' | translate }}
    </button>

    <button
        type="button"
        class="mat-raised-button buttonTheme"
        (click)="onOKClick()">
        {{ 'submit' | translate }}
    </button>

</mat-dialog-actions>